import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "ta-l" };
const _hoisted_2 = { class: "ta-c" };
const _hoisted_3 = { class: "ta-c" };
const _hoisted_4 = { class: "ta-c" };
const _hoisted_5 = { class: "ta-c" };
const _hoisted_6 = { class: "ta-c" };
const _hoisted_7 = { class: "ta-c" };
const _hoisted_8 = { class: "ta-c" };
const _hoisted_9 = { class: "ta-c" };
const _hoisted_10 = { class: "ta-r" };
const _hoisted_11 = { class: "ta-r" };
const _hoisted_12 = { class: "ta-c" };
import { withModifiers } from 'vue';
import { getTrHighlightValue } from '@/directive/commonDirective';
import vuexStore from '@/vuex-store';
import { deliveryChargeActionType } from '@/vuex-store/delivery-charge-dialog/actions';
import { alertActionType } from '@/vuex-store/alert/actions';
import { initAutoLc } from '@/locales/ko/views/delivery_charge_dialog';
import { i18n } from '@/locales';
import Chip from '@/components/Common/Chip.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChargeItem',
    props: {
        internalItem: { default: {} },
        toggleSelect: { default: {} },
        item: {},
        isSelected: { type: Function, default: () => { } }
    },
    setup(__props) {
        const lcDialog = initAutoLc('dialog_cancel_edit.');
        const props = __props;
        const thisId = props.item.id;
        const getSelectedId = () => vuexStore.state.deliveryChargeDialog.selectedItem?.id;
        const highlight = getTrHighlightValue(thisId, getSelectedId);
        /**
         * 변경 확인창
         */
        const confirm = () => vuexStore.dispatch(alertActionType.confirm, {
            headerTitle: lcDialog('title'),
            bodyContent: i18n.t('common.confirm_before_cancel'),
            btnConfig: [
                {
                    text: 'cancel',
                    cssClass: 'outlined info',
                },
                {
                    text: 'ok',
                    cssClass: 'danger',
                },
            ],
        });
        /**
         * 수정 클릭 핸들러
         */
        const handleClickEdit = async () => {
            const { selectedItem } = vuexStore.state.deliveryChargeDialog;
            const selectedItemId = selectedItem?.id;
            const currentItemId = props.item.id;
            try {
                await vuexStore.dispatch(deliveryChargeActionType.confirmChanged, confirm);
            }
            catch (error) {
                console.log('deliveryCharge/ChargeItem/handleClickEdit', error);
                vuexStore.dispatch(deliveryChargeActionType.setToggleForm, false);
                await vuexStore.dispatch(deliveryChargeActionType.cancelEdit);
                if (selectedItemId !== currentItemId) {
                    vuexStore.dispatch(deliveryChargeActionType.setToggleForm, true);
                    return vuexStore.dispatch(deliveryChargeActionType.selectItem, currentItemId);
                }
            }
            return false;
        };
        return (_ctx, _cache) => {
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _directive_tr_highlight = _resolveDirective("tr-highlight");
            return _withDirectives((_openBlock(), _createElementBlock("tr", { onClick: handleClickEdit }, [
                _createElementVNode("td", null, [
                    _createVNode(_component_v_checkbox, {
                        "model-value": _ctx.isSelected([_ctx.internalItem]),
                        density: "compact",
                        "hide-details": "",
                        disabled: false,
                        onclick: withModifiers(() => _ctx.toggleSelect(_ctx.internalItem), ['stop'])
                    }, null, 8 /* PROPS */, ["model-value", "onclick"])
                ]),
                _createCommentVNode(" 아이디 "),
                _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.item.id), 1 /* TEXT */),
                _createCommentVNode(" 구분 "),
                _createElementVNode("td", _hoisted_2, [
                    _createVNode(Chip, {
                        label: "",
                        small: "",
                        class: "pay-type__chip",
                        "brg-chip-color": _ctx.item.color,
                        text: _ctx.item.printType
                    }, null, 8 /* PROPS */, ["brg-chip-color", "text"])
                ]),
                _createCommentVNode(" 시간 "),
                _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.item.businessHourStart) + " ~ " + _toDisplayString(_ctx.item.businessHourEnd), 1 /* TEXT */),
                _createCommentVNode(" 도착지(지명) "),
                _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.item.specialArea), 1 /* TEXT */),
                _createCommentVNode(" 시작KM(이상) "),
                _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.item.distanceStart), 1 /* TEXT */),
                _createCommentVNode(" 도착KM(미만) "),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.item.distanceEnd), 1 /* TEXT */),
                _createCommentVNode(" 번지시작(이상) "),
                _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.item.addressJibunStart), 1 /* TEXT */),
                _createCommentVNode(" 번지종료(이하) "),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.item.addressJibunEnd), 1 /* TEXT */),
                _createCommentVNode(" 구역명 "),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.item.areaName), 1 /* TEXT */),
                _createCommentVNode(" 대행료 "),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.item.charge), 1 /* TEXT */),
                _createCommentVNode(" 할증배달대행료 "),
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.item.surcharge), 1 /* TEXT */),
                _createCommentVNode(" 적용요일 "),
                _createElementVNode("td", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.printWorkingDay, ({ value, isWork }, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: _normalizeClass(["day", isWork ? 'on' : 'off'])
                        }, _toDisplayString(value), 3 /* TEXT, CLASS */));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ])), [
                [_directive_tr_highlight, _unref(highlight)()]
            ]);
        };
    }
});
